// Mostra a tela com uma mensagem de confirmação. 
window.Mensagem = function (Mensagem, tipo, funcaoSim, funcaoNao) {
    if (document.querySelectorAll('#MessageConfirm').length >= 1) {
        return;
    }

    const Sim_ = `<script> function Sim() { 
                        document.activeElement.blur(); // Remove foco antes de fechar
                        $('#MessageConfirm').modal('hide'); 
                        setTimeout(function () { 
                            $('#mensagens_do_sistema').empty(); 
                            ${funcaoSim} 
                        }, 300); 
                  }</script>`;

    const Nao_ = `<script> function Nao() { 
                        document.activeElement.blur(); // Remove foco antes de fechar
                        $('#MessageConfirm').modal('hide'); 
                        setTimeout(function () { 
                            $('#mensagens_do_sistema').empty(); 
                            ${funcaoNao} 
                        }, 300); 
                 }</script>`;

    $("#mensagens_do_sistema").empty();

    const modalHtml = `
                        <div id="MessageConfirm" role="dialog" class="modal fade" data-backdrop="static" data-keyboard="false" tabindex="-1">
                            <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable modal-md">
                                <div class="modal-content">
                                    <div class="modal-header bg-primary text-white">
                                        <h5 class="modal-title"><strong><i class="bi bi-chat-dots-fill" style="color:white"></i> Mensagem </strong></h5>
                                    </div>
                                    <div class="modal-body">
                                        <div id="msg" name="msg"></div>
                                    </div>
                                    <div class="modal-footer" id="botoes" name="botoes"></div>
                                </div>
                            </div>
                        </div>
    ${Sim_} ${Nao_}`;

    $("#mensagens_do_sistema").append(modalHtml);

    let botoes;

    if (tipo === 'Pergunta') {
        botoes = `
            <button type='button' id='btnSim' name='btnSim' class='btn btn-primary' onclick='Sim()'>Sim</button>
            <button type='button' class='btn btn-secondary' id='btnNao' name='btnNao' onclick='Nao()'>Não</button>
        `;
    } else {
        botoes = `<button type='button' id='btnOk' name='btnOk' class='btn btn-primary' onclick='Sim()'>Ok</button>`;
    }

    $('#msg').html(`<i class="bi bi-info-circle-fill text-info"></i> ${Mensagem}`);
    $('#botoes').html(botoes);

    $('#MessageConfirm').modal('show');
    $('#MessageConfirm')[0].style.zIndex = '9999';

    $('#MessageConfirm').on('hidden.bs.modal', function () {
        // Remove o modal após fechar
        $('#mensagens_do_sistema').empty();
        // Retorna foco a um elemento seguro
        setTimeout(() => {
            document.body.focus(); // Foco no corpo da página
        }, 10);
    });

    setTimeout(function () {
        $('.modal-backdrop').css('opacity', '0.3');
        if (tipo === 'Pergunta') {
            $("#btnSim").focus();
        } else {
            $("#btnOk").focus(); 
        }
    }, 500);
};

